<div *ngIf='inCartQty'
     class='flex-1 text-sm font-medium text-center text-green-700 px-4 whitespace-nowrap'>
    <fa-icon [icon]='check' size='sm'></fa-icon>
    {{ inCartQty }} <span class='md:hidden lg:inline'>in cart</span>
</div>
